<template>
    <div>
        <el-tabs v-model="activeTab" tab-position="top">
            <el-tab-pane label="C/C++语言" name="tab1">

                <div class="main-content_pane_div">
                    <div class="content_pane_div_let">
                        <div class="content_pane_div_let_div">


                            <div class="dmsl">
                                <div class="butt_div">
                                    <div><span class="shili">示例:</span><el-button
                                             >直接下载</el-button><el-button @click="openWeChatChat()">联系客服</el-button></div>
                                </div>
                                <div class="shilidiv">实例：</div>
                                <pre class="json-code">

                                    <span class="lv">// demo.cpp : 定义控制台应用程序的入口点。</span>
                                    <span class="lv">//</span>

                                    #<span class="hong_">include</span> <span class="lan_">"stdafx.h"</span>
                                    #<span class="hong_">include</span> <span class="lan_">"curl/curl.h"</span>
                                    #pragma comment(lib, <span class="lan_">"libcurl.lib"</span>)
                                    static size_t write_buff_data(char *buffer, size_t size, size_t nitems, void *outstream)
                                    {
                                        memcpy(outstream, buffer, nitems*size);
                                        return nitems*size;
                                    }
                                    <span class="lv">/*</span>
                                    <span class="lv">使用http代理</span>
                                    <span class="lv">*/</span>


                                    <span class="hong_">int</span> GetUrlHTTP(char *url, char *buff)
                                    {
                                        CURL *curl;
                                        CURLcode res;
                                        curl = curl_easy_init();
                                        <span class="hong_">if</span> (curl)
                                        {
                                            curl_easy_setopt(curl, CURLOPT_PROXY,<span class="lan_">"http://测试ip:端口"</span>);
                                            curl_easy_setopt(curl, CURLOPT_WRITEDATA, (void*)buff);
                                            curl_easy_setopt(curl, CURLOPT_WRITEFUNCTION, write_buff_data);
                                            curl_easy_setopt(curl, CURLOPT_URL, url);
                                            curl_easy_setopt(curl, CURLOPT_LOW_SPEED_TIME, 10L);
                                            curl_easy_setopt(curl, CURLOPT_LOW_SPEED_LIMIT, 50L);
                                            curl_easy_setopt(curl, CURLOPT_MAX_RECV_SPEED_LARGE, 2000000L);/*下载最高速度*/
                                            res = curl_easy_perform(curl);
                                            curl_easy_cleanup(curl);
                                            <span class="hong_">if</span> (res == CURLE_OK){
                                                return res;
                                            }<span class="hong_">else</span> {
                                                printf(<span class="lan_"></span>"错误代码:%d\n", res);
                                                MessageBox(NULL, TEXT(<span class="lan_">"获取IP错误"</span>), TEXT(<span class="lan_">"助手"</span>), MB_ICONINFORMATION | MB_YESNO);
                                            }
                                        }
                                        return res;
                                    }
                                    /*
                                    使用socks5代理
                                    */
                                    <span class="hong_">int</span> GetUrlSocks5(char *url, char *buff)
                                    {
                                        CURL *curl;
                                        CURLcode res;
                                        curl = curl_easy_init();
                                        <span class="hong_">if</span> (curl)
                                        {
                                            curl_easy_setopt(curl, CURLOPT_PROXY, <span class="lan_">"socks5://测试ip:端口"</span>);
                                            curl_easy_setopt(curl, CURLOPT_WRITEDATA, (void*)buff);
                                            curl_easy_setopt(curl, CURLOPT_WRITEFUNCTION, write_buff_data);
                                            curl_easy_setopt(curl, CURLOPT_URL, url);
                                            curl_easy_setopt(curl, CURLOPT_LOW_SPEED_TIME, 10L);
                                            curl_easy_setopt(curl, CURLOPT_LOW_SPEED_LIMIT, 50L);
                                            curl_easy_setopt(curl, CURLOPT_MAX_RECV_SPEED_LARGE, 2000000L);/*下载最高速度*/
                                            res = curl_easy_perform(curl);
                                            curl_easy_cleanup(curl);
                                            <span class="hong_">if</span> (res == CURLE_OK) {
                                                return res;
                                            }
                                            <span class="hong_">else</span> {
                                                printf("错误代码:%d\n", res);
                                                MessageBox(NULL, TEXT(<span class="lan_">"获取IP错误"</span>), TEXT(<span class="lan_">"助手"</span>), MB_ICONINFORMATION | MB_YESNO);
                                            }
                                        }
                                        return res;
                                    }
                                    <span class="hong_">int</span> GetUrl(char *url, char *buff)
                                    {
                                        CURL *curl;
                                        CURLcode res;
                                        curl = curl_easy_init();
                                        <span class="hong_">if</span> (curl)
                                        {
                                            curl_easy_setopt(curl, CURLOPT_WRITEDATA, (void*)buff);
                                            curl_easy_setopt(curl, CURLOPT_WRITEFUNCTION, write_buff_data);
                                            curl_easy_setopt(curl, CURLOPT_URL, url);
                                            curl_easy_setopt(curl, CURLOPT_LOW_SPEED_TIME, 10L);
                                            curl_easy_setopt(curl, CURLOPT_LOW_SPEED_LIMIT, 50L);
                                            curl_easy_setopt(curl, CURLOPT_MAX_RECV_SPEED_LARGE, 2000000L);/*下载最高速度*/
                                            res = curl_easy_perform(curl);
                                            curl_easy_cleanup(curl);
                                            <span class="hong_">if</span> (res == CURLE_OK)
                                            {
                                                return res;
                                            }
                                            <span class="hong_">else</span> {
                                                printf("错误代码:%d\n", res);
                                                MessageBox(NULL, TEXT(<span class="lan_">"获取IP错误"</span>), TEXT(<span class="lan_">"助手"</span>), MB_ICONINFORMATION | MB_YESNO);
                                            }
                                        }
                                        return res;
                                    }
                                    <span class="hong_">int</span> main()
                                    {
                                        <span class="hong_">char</span> *buff=(<span class="hong_">char</span>*)malloc(1024*1024);
                                        memset(buff, 0, 1024 * 1024);

                                        GetUrl(<span class="lan_">"http://baidu.com"</span>, buff);
                                        printf("不使用代理：%s\n", buff);

                                        memset(buff, 0, 1024 * 1024);
                                        GetUrlHTTP(<span class="lan_">"http://baidu.com"</span>, buff);
                                        printf("http结果：%s\n", buff);

                                        memset(buff, 0,1024 * 1024);
                                        GetUrlSocks5(<span class="lan_">"http://baidu.com"</span>, buff);
                                        printf("socks5结果：%s\n", buff);


                                        Sleep(1000 * 1000);
                                        free(buff);
                                        return 0;
                                    }
                                </pre>
                            </div>
                        </div>

                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="GO语言" name="tab2">


                <div class="main-content_pane_div">
                    <div class="content_pane_div_let">
                        <div class="content_pane_div_let_div">


                            <div class="dmsl">
                                <div class="butt_div">
                                    <div><span class="shili">示例:</span><el-button
                                             >直接下载</el-button><el-button @click="openWeChatChat()">联系客服</el-button></div>
                                </div>
                                <div class="shilidiv">实例：</div>
                                <!-- lv   hong_  lan_ -->
                                <pre class="json-code">

                                                <span class="hong_">package</span> main

                                                <span class="hong_">import</span> (
                                                    <span class="lan_">"context"</span>
                                                    <span class="lan_">"fmt"</span>
                                                    <span class="lan_">"golang.org/x/net/proxy"</span>
                                                    <span class="lan_">"io/ioutil"</span>
                                                    <span class="lan_">"net"</span>
                                                    <span class="lan_">"net/http"</span>
                                                    <span class="lan_">"net/url"</span>
                                                    <span class="lan_">"strings"</span>
                                                    <span class="lan_">"time"</span>
                                                )

                                                <span class="hong_">var</span> testApi = <span class="lan_"></span>" http://apiupss.ppfly.top"

                                                <span class="hong_">func</span> main() {
                                                    getMyIp()

                                                    //白名单代理
                                                    <span class="hong_">var</span> proxyIP = <span class="lan_">"ip:port"</span>
                                                    <span class="hong_">go</span> httpProxy(proxyIP, <span class="lan_">""</span>, <span class="lan_">""</span>)
                                                    <span class="hong_">go</span> Socks5Proxy(proxyIP, <span class="lan_">""</span>, <span class="lan_">""</span>)
                                                    time.Sleep(time.Minute)
                                                }

                                                <span class="hong_">func</span> getMyIp() {
                                                    rsp, err := http.Get(<span class="lan_"></span>" http://apiupss.ppfly.top")
                                                    <span class="hong_">if</span> err != nil {
                                                        fmt.Println("获取本机ip失败", err.Error())
                                                        return
                                                    }
                                                    defer rsp.Body.Close()
                                                    body, err := ioutil.ReadAll(rsp.Body)
                                                    <span class="hong_">if</span> err != nil {
                                                        fmt.Println(err.Error())
                                                        return
                                                    }
                                                    fmt.Println(time.Now().Format(<span class="lan_"></span>"2006-01-02 15:04:05 07"), <span class="lan_"></span>"本机ip:", string(body))

                                                }

                                                //http代理
                                                <span class="hong_">func</span> httpProxy(proxyUrl, user, pass string) {
                                                    <span class="hong_">defer</span> func() {
                                                        if err := recover(); err != nil {
                                                            fmt.Println(time.Now().Format(<span class="lan_"></span>"2006-01-02 15:04:05 07"), <span class="lan_"></span>"http", <span class="lan_"></span>"返回信息:", err)
                                                        }
                                                    }()
                                                    urli := url.URL{}

                                                    <span class="hong_">if</span> !strings.Contains(proxyUrl, "http") {
                                                        proxyUrl = fmt.Sprintf(<span class="lan_"></span>"http://%s", proxyUrl)
                                                    }

                                                    urlProxy, _ := urli.Parse(proxyUrl)
                                                    <span class="hong_">if</span> user != <span class="lan_"></span>"" && pass != <span class="lan_"></span>"" {
                                                        urlProxy.User = url.UserPassword(user, pass)
                                                    }

                                                    client := &http.Client{
                                                        Transport: &http.Transport{
                                                            Proxy: http.ProxyURL(urlProxy),
                                                        },
                                                    }
                                                    rqt, err := http.NewRequest(<span class="lan_"></span>"GET", testApi, nil)
                                                    <span class="hong_">if</span> err != nil {
                                                        panic(err)
                                                        return
                                                    }
                                                    response, err := client.Do(rqt)
                                                    <span class="hong_">if</span> err != nil {
                                                        panic(err)
                                                        return
                                                    }

                                                    defer response.Body.Close()
                                                    body, _ := ioutil.ReadAll(response.Body)
                                                    fmt.Println(time.Now().Format(<span class="lan_">"2006-01-02 15:04:05 07"</span>), proxyUrl, <span class="lan_">"【http success】"</span>, <span class="lan_">"返回信息:"</span>, response.Status, string(body))

                                                    return
                                                }

                                                //socks5代理
                                                <span class="hong_">func</span> Socks5Proxy(proxyUrl, user, pass string) {

                                                    <span class="hong_">defer</span> func() {
                                                        if err := recover(); err != nil {
                                                            fmt.Println(time.Now().Format(<span class="lan_">"2006-01-02 15:04:05 07"</span>), proxyUrl, <span class="lan_">"返回信息:"</span>, err)
                                                        }
                                                    }()

                                                    <span class="hong_">var</span> userAuth proxy.Auth
                                                    <span class="hong_">if</span> user != <span class="lan_">""</span> && pass != <span class="lan_">""</span> {
                                                        userAuth.User = user
                                                        userAuth.Password = pass
                                                    }
                                                    dialer, err := proxy.SOCKS5(<span class="lan_"></span>"tcp", proxyUrl, &userAuth, proxy.Direct)
                                                    <span class="hong_">if</span> err != nil {
                                                        panic(err)
                                                    }
                                                    httpClient := &http.Client{
                                                        Transport: &http.Transport{
                                                            DialContext: func(ctx context.Context, network, addr string) (conn net.Conn, err error) {
                                                                return dialer.Dial(network, addr)
                                                            },
                                                        },
                                                        Timeout: time.Second * 10,
                                                    }

                                                    //请求网络
                                                    <span class="hong_">if</span> resp, err := httpClient.Get(testApi); err != nil {
                                                        panic(err)
                                                    } <span class="hong_">else</span> {
                                                        defer resp.Body.Close()
                                                        body, _ := ioutil.ReadAll(resp.Body)
                                                        fmt.Println(time.Now().Format(<span class="lan_">"2006-01-02 15:04:05 07"</span>), proxyUrl, <span class="lan_">"【socks5 success】"</span>, <span class="lan_">"返回信息:"</span>, string(body))
                                                    }
                                                }

                                </pre>
                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="Node.js语言" name="tab3">


                <div class="main-content_pane_div">
                    <div class="content_pane_div_let">
                        <div class="content_pane_div_let_div">


                            <div class="dmsl">
                                <div class="butt_div">
                                    <div><span class="shili">示例:</span>
                                        <el-button  >直接下载</el-button>
                                        <el-button @click="openWeChatChat()">联系客服</el-button></div>
                                </div>
                                <div class="shilidiv">实例：</div>
                                <pre class="json-code">
                                 <!-- lv   hong_  lan_ -->

#!<span class="lan_">/usr/</span>bin/env node
require(<span class="lan_">'request-promise'</span>)({
    url: <span class="lan_">'http://apiupss.ppfly.top'</span>,
    proxy: <span class="lan_">'http://ip:port'</span>,
    })
    .then(<span class="hong_">function</span>(data){ <span class="">console.log(data)</span>; },
          <span class="hong_">function</span>(err){ <span class="">console.error(err)</span>; });

                                </pre>
                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="Php语言" name="tab4">


                <div class="main-content_pane_div">
                    <div class="content_pane_div_let">
                        <div class="content_pane_div_let_div">


                            <div class="dmsl">
                                <div class="butt_div">
                                    <div><span class="shili">示例:</span><el-button
                                             >直接下载</el-button><el-button @click="openWeChatChat()">联系客服</el-button></div>
                                </div>
                                <div class="shilidiv">实例：</div>
                                <pre class="json-code">


                                    <!-- lv   hong_  lan_ -->
<?php
<span class='lv'>// 要访问的目标页面</span>
	$targetUrl = <span class='lan_'>"http://baidu.com";</span>
	<span class='lv'>// 代理服务器</span>
	$proxyServer = <span class='lan_'>"http://{{iptext}}:{{domaintext}}"</span>;

	<span class='lv'>// 隧道身份信息</span>
	$ch = curl_init();
	curl_setopt($ch, CURLOPT_URL, $targetUrl);
	curl_setopt($ch, CURLOPT_HTTPPROXYTUNNEL, false);
	curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);

	<span class='lv'>// 设置代理服务器</span>
	curl_setopt($ch, CURLOPT_PROXYTYPE, 0); //http
	<span class='lv'>// curl_setopt($ch, CURLOPT_PROXYTYPE, 5); //sock5</span>
	curl_setopt($ch, CURLOPT_PROXY, $proxyServer);

	<span class='lv'>// 设置隧道验证信息</span>
	curl_setopt($ch, CURLOPT_PROXYAUTH, CURLAUTH_BASIC);
	curl_setopt($ch, CURLOPT_USERAGENT, <span class='lan_'>"Mozilla/4.0 (compatible; MSIE 6.0; Windows NT 5.1; SV1; .NET CLR 2.0.50727;)"</span>);
	curl_setopt($ch, CURLOPT_CONNECTTIMEOUT, 3);
	curl_setopt($ch, CURLOPT_TIMEOUT, 5);
	curl_setopt($ch, CURLOPT_HEADER, true);
	curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
	$result = curl_exec($ch);
	$err = curl_error($ch);

	curl_close($ch);

	var_dump($err);
	var_dump($result);

                                </pre>
                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="JAVA语言" name="tab5">


                <div class="main-content_pane_div">
                    <div class="content_pane_div_let">
                        <div class="content_pane_div_let_div">


                            <div class="dmsl">
                                <div class="butt_div">
                                    <div><span class="shili">示例:</span><el-button
                                             >直接下载</el-button><el-button @click="openWeChatChat()">联系客服</el-button></div>
                                </div>
                                <div class="shilidiv">实例：</div>
                                <pre class="json-code">

     <!-- lv   hong_  lan_ -->
<span class="hong_">package</span> demo;

<span class="hong_">import</span> okhttp3.OkHttpClient;
<span class="hong_">import</span> okhttp3.Request;

<span class="hong_">import</span> java.io.IOException;
<span class="hong_">import</span> java.net.InetSocketAddress;
<span class="hong_">import</span> java.net.Proxy;

<span class="lv">/**</span>
<span class="lv">* compile 'com.squareup.okhttp3:okhttp:3.10.0'</span>
<span class="lv">*/</span>
 <span class="hong_">class</span> ApiProxyJava {
    <span class="hong_">public static void</span> main(String[] args) throws IOException {
        testHttpWithOkHttp();
        testSocks5WithOkHttp();
    }

    <span class="hong_">public static void</span> testHttpWithOkHttp() throws IOException {
        <span class="zi">String</span> <span class="cheng">url</span> = <span class="lan_">"http://apiupss.ppfly.top"</span>;
        <span class="zi">Proxy</span> <span class="cheng">proxy</span> = <span class="zi">new</span> <span class="zi">Proxy</span>(Proxy.Type.HTTP, <span class="zi">new</span> InetSocketAddress(<span class="lan_">"ip"</span>, 2000));
        <span class="zi">OkHttpClient</span> <span class="cheng">client</span> = <span class="zi">new</span> <span class="zi">OkHttpClient</span>().newBuilder().proxy(proxy).build();

        <span class="zi">Request</span> <span class="cheng">request</span> = <span class="zi">new</span> <span class="zi">Request</span>.Builder().url(url).build();
        okhttp3.Response <span class="cheng">response</span> = client.newCall(request).execute();
        <span class="zi">String</span> <span class="cheng">responseString</span> = response.body().string();
        System.out.println(responseString);
    }

    <span class="hong_">public static void</span> testSocks5WithOkHttp() throws IOException {
        <span class="zi">String</span> <span class="cheng">url</span> = <span class="lan_">"http://apiupss.ppfly.top"</span>;
        <span class="zi">Proxy</span> <span class="cheng">proxy</span> = <span class="zi">new</span> <span class="zi">Proxy</span>(Proxy.Type.SOCKS, <span class="zi">new</span> InetSocketAddress(<span class="lan_">"ip"</span>, 8080));
        <span class="zi">OkHttpClient</span> <span class="cheng">client</span> = <span class="zi">new</span> <span class="zi">OkHttpClient</span>().newBuilder().proxy(proxy).build();

        <span class="zi">Request</span> <span class="cheng">request</span> = <span class="zi">new</span> <span class="zi">Request</span>.Builder().url(url).build();
        okhttp3.Response <span class="cheng">response</span> = client.newCall(request).execute();
        <span class="zi">String</span> <span class="cheng">responseString</span> = <span class="zi"></span>response.body().string();
        System.out.println(responseString);
    }
}
                                </pre>
                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="python语言" name="tab6">


                <div class="main-content_pane_div">
                    <div class="content_pane_div_let">
                        <div class="content_pane_div_let_div">


                            <div class="dmsl">
                                <div class="butt_div">
                                    <div><span class="shili">示例:</span><el-button
                                             >直接下载</el-button><el-button @click="openWeChatChat()">联系客服</el-button></div>
                                </div>
                                <div class="shilidiv">实例：</div>
                                <pre class="json-code">

                 <!-- lv   hong_  lan_ -->

                  <span class="hong_"></span>
                  <span class="lan_"></span>
<span class="lv"></span># coding=utf-8
<span class="lv"></span># ！/usr/bin/env python
<span class="zi"></span>import json
<span class="zi"></span>import threading
<span class="zi"></span>import time
<span class="zi"></span>import requests <span class="zi"></span>as rq

headers = {
    <span class="lan_">"User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:85.0) Gecko/20100101 Firefox/85.0",</span>
    <span class="lan_">"Accept": "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8",</span>
    <span class="lan_">"Accept-Language": "zh-CN,zh;q=0.8,zh-TW;q=0.7,zh-HK;q=0.5,en-US;q=0.3,en;q=0.2",</span>
    <span class="lan_">"Accept-Encoding": "gzip, deflate, br"</span>
}
testUrl = <span class="lan_">' http://apiupss.ppfly.top'</span>


# 核心业务
<span class="heng">def</span> testPost(host, port):
    proxies = {
        <span class="lan_">'http': 'http://{}:{}'.</span><span class="lan_">format(host, port),</span>
        <span class="lan_">'https': 'http://{}:{}'.</span><span class="lan_">format(host, port),</span>
    }
    res = <span class="lan">""</span>

    <span class="hong_">while</span> <span class="cheng">True</span>:
        <span class="hong_">try</span>:
            res = rq.get(testUrl, proxies=proxies, timeout=5)
            <span class="lv"># print(res.status_code)</span>
            <span class="hong_">print</span>(res.status_code, <span class="lan_">"***"</span>, res.text)
            <span class="hong_">break</span>
        <span class="hong_">except</span> Exception <span class="zi">as</span> e:
            <span class="hong_">print</span>(e)
            <span class="hong_">break</span>

    <span class="zi">return</span>


<span class="zi">class</span> <span class="zi">ThreadFactory</span>(threading.Thread):
    <span class="hong_">def</span> __init__(self, host, port):
        threading.Thread.__init__(self)
        self.host = host
        self.port = port

    <span class="hong_">def</span> run(self):
        testPost(self.host, self.port)


# 提取代理的链接  json类型的返回值
tiqu = <span class="lan_">'提取链接'</span>

<span class="hong_">while</span> <span class="lan_">1</span> == <span class="lan_">1</span>:
    <span class="lv"># 每次提取10个，放入线程中</span>
    resp = rq.get(url=tiqu, timeout=<span class="lan_">5</span>)
    <span class="hong_">try</span>:
        <span class="hong_">if</span> resp.status_code == <span class="lan_">200</span>:
            dataBean = json.loads(resp.text)
        <span class="hong_">else</span>:
            print(<span class="lan_">"获取失败"</span>)
            time.sleep(<span class="lan_">1</span>)
            <span class="hong_">continue</span>
    <span class="hong_">except</span> ValueError:
        <span class="hong_">print</span>(<span class="lan_">"获取失败"</span>)
        time.sleep(<span class="lan_">1</span>)
        <span class="hong_">continue</span>
    <span class="hong_">else</span>:
        <span class="lv"># 解析json数组</span>
        <span class="hong_">print</span>(<span class="lan_">"code="</span>, dataBean[<span class="lan_">"code="</span>])
        code = dataBean[<span class="lan_">"code="</span>]
        <span class="hong_">if</span> code == <span class="lan_">0</span>:
            threads = []
            <span class="hong_">for</span> proxy in dataBean[<span class="lan_">"data"</span>]:
                threads.append(ThreadFactory(proxy[<span class="lan_">"ip"</span>], proxy[<span class="lan_">"code="</span>]))
            <span class="hong_">for</span> t <span class="hong_">in</span> threads:  <span class="lv"># 开启线程</span>
                t.start()
                time.sleep(<span class="lan_">0.01</span>)
            <span class="hong_">for</span> t <span class="zi">in</span> threads:  <span class="lv"># 阻塞线程</span>
                t.join()
    <span class="lv"># break</span>
    time.sleep(<span class="lan_">1</span>)




                                </pre>
                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="python-selenium语言" name="tab7">


                <div class="main-content_pane_div">
                    <div class="content_pane_div_let">
                        <div class="content_pane_div_let_div">


                            <div class="dmsl">
                                <div class="butt_div">
                                    <div><span class="shili">示例:</span><el-button
                                             >直接下载</el-button><el-button @click="openWeChatChat()">联系客服</el-button></div>
                                </div>
                                <div class="shilidiv">实例：</div>
                                <pre class="json-code">

<span class="hong_">from</span> selenium <span class="hong_">import</span> webdriver
<span class="hong_">from</span> selenium.webdriver.chrome.options <span class="hong_">import</span> Options
<span class="hong_">import</span> requests

<span class="hong_">def</span> seleniumSetUP(ip,port):
    <span class="lv"># 设置Chrome驱动程序的路径</span>
    <span class="lv"># 创建Chrome浏览器实例</span>
    chrome_options = Options()
    <span class="lv"># 配置获取到的ip和port</span>
    chrome_options.add_argument(<span class="lan_">f'--proxy-server=http://</span>ip<span class="lan_">:</span>{port}<span class="lan_">'</span>)
    browser = webdriver.Chrome(options=chrome_options)
    # 使用代理访问
    browser.get(<span class="lan_">'http://apiupss.ppfly.top/index.html'</span>)
    <span class="hong_">print</span>(browser.page_source)

<span class="hong_">if</span> __name__ == <span class="lan_">'__main__'</span>:
    <span class="lv"># 获取代理的url，一次仅获取一条</span>
    porxyUrl = <span class="lan_">"http://apiupss.ppfly.top"</span>
    <span class="lv"># 访问并获取代理</span>
    ipInfo = requests.get(porxyUrl)
    <span class="hong_">print</span>(ipInfo.json())
    info = ipInfo.json()[<span class="lan_">"data"</span>]
    <span class="lv"># 解析json，获取代理服务器地址</span>
    ip = info[<span class="lan_">0</span>][<span class="lan_">"ip"</span>]
    <span class="lv"># 解析json，获取代理的端口</span>
    port = info[<span class="lan_">0</span>][<span class="lan_">"port"</span>]
    <span class="lv"># 获取到的代理信息传入到selenium中进行配置</span>
    seleniumSetUP(ip,port)


                                </pre>
                            </div>
                        </div>
                    </div>
                </div>

            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
export default {
  data() {
    return {
      domaintext: "domain",
      iptext: "ip",
      shifoudiqu: false,
      maindiv: "",
      activeTab: "tab1",
      isActive: false,
      isActiveB: false,
      form: {
        package: "",
        quantity: "",
        dataFormat: "",
        country: "",
        proxyAgreement: "",
        separator: "",
      },
      quanqiu: [
        { name: "全球混播" },
        { name: "美国" },
        { name: "韩国" },
        { name: "日本" },
        { name: "中国香港" },
        { name: "菲律宾" },
        { name: "越南" },
        { name: "印度" },
        { name: "缅甸" },
        { name: "泰国" },
        { name: "马来西亚" },
        { name: "中国台湾" },
        { name: "印度尼西亚" },
        { name: "孟加拉国" },
        { name: "巴基斯坦" },
        { name: "巴林" },
        { name: "科威特" },
        { name: "阿曼" },
        { name: "卡塔尔" },
        { name: "沙特阿拉伯" },
        { name: "阿联酋" },
        { name: "伊拉克" },
        { name: "以色列" },
        { name: "约旦" },
        { name: "阿塞拜疆" },
        { name: "伊朗" },
        { name: "土耳其" },
        { name: "哈萨克斯坦" },
        { name: "乌兹别克斯坦" },
        { name: "新加坡" },
        { name: "中国澳门" },
        { name: "文莱" },
        { name: "柬埔寨" },
        { name: "老挝" },
        { name: "法国" },
        { name: "英国" },
        { name: "德国" },
        { name: "卢森堡" },
        { name: "俄罗斯" },
        { name: "白俄罗斯" },
        { name: "比利时" },
        { name: "奥地利" },
        { name: "西班牙" },
        { name: "爱尔兰" },
        { name: "芬兰" },
        { name: "葡萄牙" },
        { name: "拉脱维亚" },
        { name: "波兰" },
        { name: "立陶宛" },
        { name: "匈牙利" },
        { name: "荷兰" },
        { name: "瑞士" },
        { name: "捷克共和国" },
        { name: "挪威" },
        { name: "希腊" },
        { name: "乌克兰" },
        { name: "丹麦" },
        { name: "罗马尼亚" },
        { name: "塞尔维亚" },
        { name: "加拿大" },
        { name: "牙买加" },
        { name: "墨西哥" },
        { name: "巴拿马" },
        { name: "哥斯达黎加" },
        { name: "危地马拉" },
        { name: "洪都拉斯" },
        { name: "波多黎各" },
        { name: "阿根廷" },
        { name: "巴西" },
        { name: "哥伦比亚" },
        { name: "智利" },
        { name: "委内瑞拉" },
        { name: "秘鲁" },
        { name: "玻利维亚" },
        { name: "厄瓜多尔" },
        { name: "圭亚那" },
        { name: "巴拉圭" },
        { name: "乌拉圭" },
        { name: "新西兰" },
        { name: "澳大利亚" },
        { name: "马达加斯加" },
        { name: "莫桑比克" },
        { name: "南非" },
        { name: "埃塞俄比亚" },
        { name: "肯尼亚" },
        { name: "加纳" },
        { name: "阿尔及利亚" },
        { name: "埃及" },
        { name: "摩洛哥" },
        { name: "突尼斯" },
        { name: "不丹" },
        { name: "马尔代夫" },
        { name: "尼泊尔" },
        { name: "斯里兰卡" },
        { name: "也门" },
        { name: "塞浦路斯" },
        { name: "黎巴嫩" },
        { name: "巴勒斯坦" },
        { name: "叙利亚" },
        { name: "阿富汗" },
        { name: "亚美尼亚" },
        { name: "土库曼斯坦" },
        { name: "格鲁吉亚" },
        { name: "东帝汶" },
        { name: "蒙古国" },
        { name: "梵蒂冈" },
        { name: "摩尔多瓦" },
        { name: "摩纳哥" },
        { name: "冰岛" },
        { name: "马耳他" },
        { name: "爱沙尼亚" },
        { name: "克罗地亚" },
        { name: "阿尔巴尼亚" },
        { name: "波黑" },
        { name: "保加利亚" },
        { name: "黑山" },
        { name: "马其顿" },
        { name: "斯洛文尼亚" },
        { name: "斯洛伐克" },
        { name: "科索沃" },
        { name: "安道尔公国" },
        { name: "泽西岛" },
        { name: "马恩岛" },
        { name: "根西岛" },
        { name: "列支敦士登" },
        { name: "欧洲" },
        { name: "直布罗陀" },
        { name: "格陵兰" },
        { name: "圣卢西亚" },
        { name: "阿鲁巴" },
        { name: "库拉索" },
        { name: "多米尼加" },
        { name: "瓜德罗普" },
        { name: "萨尔瓦多" },
        { name: "特立尼达和多巴哥" },
        { name: "巴哈马" },
        { name: "多米尼加共和国" },
        { name: "伯利兹" },
        { name: "巴巴多斯" },
        { name: "荷属圣马丁" },
        { name: "圣文森特岛" },
        { name: "安提瓜和巴布达" },
        { name: "尼加拉瓜" },
        { name: "海地共和国" },
        { name: "开曼群岛" },
        { name: "法属圣马丁" },
        { name: "美属维尔京群岛" },
        { name: "马提尼克" },
        { name: "英属维尔京群岛" },
        { name: "圣基茨和尼维斯" },
        { name: "百慕大" },
        { name: "苏里南" },
        { name: "法属圭亚那" },
        { name: "帕劳" },
        { name: "斐济群岛" },
        { name: "巴布亚新几内亚" },
        { name: "新喀里多尼亚" },
        { name: "法属波利尼西亚" },
        { name: "关岛" },
        { name: "托克劳" },
        { name: "密克罗尼西亚联邦" },
        { name: "所罗门群岛" },
        { name: "瓦努阿图" },
        { name: "美属萨摩亚" },
        { name: "安哥拉" },
        { name: "布基纳法索" },
        { name: "贝宁" },
        { name: "博茨瓦纳" },
        { name: "刚果(布)" },
        { name: "科特迪瓦" },
        { name: "加蓬" },
        { name: "利比亚" },
        { name: "马里" },
        { name: "毛里求斯" },
        { name: "纳米比亚" },
        { name: "留尼汪" },
        { name: "卢旺达" },
        { name: "苏丹" },
        { name: "塞内加尔" },
        { name: "南苏丹" },
        { name: "多哥" },
        { name: "乌干达" },
        { name: "津巴布韦" },
        { name: "坦桑尼亚" },
        { name: "毛里塔尼亚" },
        { name: "索马里" },
        { name: "冈比亚" },
        { name: "格林纳达" },
        { name: "刚果金" },
        { name: "喀麦隆" },
        { name: "赞比亚共和国" },
        { name: "圣多美和普林西比" },
        { name: "佛得角共和国" },
        { name: "赤道几内亚" },
        { name: "马拉维" },
        { name: "吉布提国家" },
        { name: "几内亚" },
        { name: "利比里亚" },
        { name: "尼日尔共和国" },
        { name: "几内亚比绍" },
        { name: "塞拉利昂" },
        { name: "莱索托" },
        { name: "斯威士兰" },
        { name: "科摩罗" },
        { name: "塞舌尔共和国" },
        { name: "马约特" },
      ],
    };
  },
  created() {
    // 在组件创建时获取路由参数
    this.userId = this.$route.params.id;
  },
  components: {},
  mounted() {},
  methods: {
    openWeChatChat() {
    },
    onclick(name) {
      console.log();
      this.maindiv = name;
    },
    toggleBorder() {
      this.isActive = true; // 切换边框状态
      this.isActiveB = false;
    },
    toggleBorderB() {
      this.isActiveB = true; // 切换边框状态
      this.isActive = false;
    },
    generateLink() {
      // 处理生成链接的逻辑
      console.log("生成链接:", this.form);
    },
  },
};
</script>
<style>
.zisei {
  background-color: #6327d3;
  border: none;
}
.zisei:hover {
  background-color: #542ca0;
}
.getapi {
}

.getapi_body {
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.el-menu-item {
  border-radius: 15px;
  text-align: left;
}

.title_img {
  text-align: left;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
  /* overflow-y: scroll; */
  height: 800px;
}

.content_pane_div_let {
}
.main-content_pane_div {
  display: flex;
  justify-content: space-between;
}

.content_pane_div_let_div {
  overflow-y: scroll;
  height: 730px;
}

.content_pane_div_let_div_div {
  display: flex;
  justify-content: space-around;
  width: 900px;
  padding: 10px;
}

.content_pane_div_let_div_divs {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 400px;
}

.content_pane_div_let_div_divsB {
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border-radius: 5px;
  width: 1400px;
}

.active-border {
  box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  /* 点击后添加的边框样式 */
}

.content_pane_div_let_div_divs:nth-child(1) {
  margin-right: 10px;
}

.content_pane_div_let_div_divs > div:nth-child(1) {
}

.content_pane_div_let_div_divs > div:nth-child(2) {
}

.content_pane_div_let_div_divs > div:nth-child(3) {
}

.zhed_cls {
  text-align: left;
  display: flex;
  align-items: center;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  color: #18181b;
}

.div_zhed_cls_text {
  margin-top: 10px;
}

.zhed_cls_text {
  font-size: 14px;
  color: #737791;
  display: flex;
  justify-content: space-between;
}

.zhed_cls_text > div {
  font-size: 16px;
  color: #000;
  line-height: 22px;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.div_xiala {
  background-color: #edf3fc;
  /* 表单背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.but_sclj {
  width: 207px;
  height: 38px;
  background: #6327d3;
  box-shadow: 0 11px 10px 0 rgba(29, 104, 250, 0.13);
  border-radius: 6px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  color: #edf3fc;
  cursor: pointer;
  margin-right: 150px;
  margin-top: 50px;
}

.main-content {
  padding: 20px;
  /* 右侧主体内容内边距 */
}

.jkcszj {
  background-color: #edf3fc;
  /* 接口参数注解背景色 */
  padding: 20px;
  /* 内边距 */
  border-radius: 5px;
  /* 圆角 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.jkcszj h2 {
  margin-bottom: 20px;
  /* 标题下边距 */
}

.no-border-table {
  width: 100%;
  border-collapse: collapse;
  /* 合并边框 */
}

.no-border-table th,
.no-border-table td {
  border: none;
  /* 无边框 */
  padding: 10px;
  /* 单元格内边距 */
  text-align: left;
  /* 左对齐 */
}

.no-border-table th {
  background-color: #f0f0f0;
  /* 表头背景色 */
}

.H2_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 16px;
  color: #18181b;
  display: flex;
  align-items: center;
  margin-left: -25px;
}

.H3_text {
  font-family: SourceHanSansCN-Bold;
  font-size: 13px;
  color: #505053;
  display: flex;
  align-items: center;
}

.top_name {
  font-size: 16px;
  font-weight: 700;
  background: #f0f9ff;
  border-radius: 7px;
  height: 48px;
  border-bottom: none;
}

.top_name_th {
  font-size: 13px;
}

.top_text {
  font-size: 14px;
  height: 40px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  font-size: 14px;
  font-weight: 400;
  color: #444a6d;
  text-align: center;
}

.json-code {
  text-align: left;
  /* 使文本左对齐 */
  background-color: #f8f8f8;
  /* 设置背景颜色 */
  /* 添加边框 */
  padding: 10px;
  /* 添加内边距 */
  overflow: auto;
  /* 处理溢出内容 */
  white-space: pre-wrap;
  /* 允许换行 */
  font-family: SimHei;
  /* 使用等宽字体 */
  font-size: 15px;
}

.lan_ {
  color: #00f;
}

.hong_ {
  color: #808;
}
.cheng {
  color: #f40;
}
.zi {
  color: #639;
}
.lv {
  color: #070;
}

.butt_div {
  display: flex;
  justify-content: left;
}

.shili {
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 16px;
  color: #18181b;
  line-height: 32px;
  margin-right: 40px;
}

.shilidiv {
  font-family: SourceHanSansCN-Regular;
  font-weight: 600;
  font-size: 16px;
  color: #18181b;
  line-height: 32px;
  margin-right: 40px;
  text-align: left;
}
</style>
